/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_apex_close_help = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close help popover`)
};

const es_f1_apex_close_help = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar ventana de ayuda`)
};

const de_f1_apex_close_help = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hilfe-Popover schließen`)
};

const nl_f1_apex_close_help = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Help-popover sluiten`)
};

const fr_f1_apex_close_help = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer la fenêtre d’aide`)
};

const it_f1_apex_close_help = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi popover di aiuto`)
};

const pt_br2_f1_apex_close_help = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar popover de ajuda`)
};

const pt_f1_apex_close_help = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar popover de ajuda`)
};

const ja_f1_apex_close_help = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ヘルプポップオーバーを閉じる`)
};

const zh_f1_apex_close_help = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭帮助弹窗`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_apex_close_help = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_apex_close_help(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_apex_close_help", locale)
	if (locale === "en") return en_f1_apex_close_help(inputs)
	if (locale === "es") return es_f1_apex_close_help(inputs)
	if (locale === "de") return de_f1_apex_close_help(inputs)
	if (locale === "nl") return nl_f1_apex_close_help(inputs)
	if (locale === "fr") return fr_f1_apex_close_help(inputs)
	if (locale === "it") return it_f1_apex_close_help(inputs)
	if (locale === "pt-BR") return pt_br2_f1_apex_close_help(inputs)
	if (locale === "pt") return pt_f1_apex_close_help(inputs)
	if (locale === "ja") return ja_f1_apex_close_help(inputs)
	return zh_f1_apex_close_help(inputs)
};